export enum FormatPhoneNumberAs {
    // This format is implemented by libphonenumber library
    International = 0,

    // This format is implemented by libphonenumber library
    National,

    // Provide your own format implementation
    TriconCustom
}